import { Address } from "viem"

export const bridgeableTokens = [
  "BTC",
  "tBTC",
  "T",
  "SolvBTC",
  "xSolvBTC",
  "USDC",
  "USDT",
  "USDe",
  "FBTC",
  "cbBTC",
  "swBTC",
  "DAI",
] as const

export type BridgeableTokens = (typeof bridgeableTokens)[number]
export type BridgeableTokenData = {
  sourceToken: Address
  mezoToken: Address
  bridgedTokenSymbol: string
}

export type BridgeAssetFormValue = {
  amount: bigint | undefined
  token: BridgeableTokens
  shouldUseAnotherWallet: boolean
  depositId?: number
}

export type BridgeType = "wormhole" | "native"
